import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';

import Stack from 'styles/stack/Stack';
import palette from 'styles/theme/Palette';

const primary = palette.primary.main;

const pillStyle = {
	width: '30px',
	height: '30px',
	display: 'flex',
	position: 'absolute',
	background: 'white',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '50%',
	border: `2px solid ${primary}`,
	boxShadow: '0 0 0 2px white',
};

const todaySx = (isInRange: boolean | null) => ({
	backgroundColor: !isInRange ? 'transparent' : '',
	border: '1px solid transparent!important',
	'&:hover': { backgroundColor: !isInRange ? 'transparent!important' : '' },
});

const inRangeSx = {
	backgroundColor: `${primary}!important`,
	borderRadius: '0!important',
	color: 'white!important',
	borderRight: `1px solid ${primary}!important`,
	'&:hover': { backgroundColor: `${primary}!important` },
};

const startWithEndSx = {
	borderRadius: 0,
	borderWidth: '0!important',
	background: `linear-gradient(to right, white 50%, ${primary} 50%)`,
	color: `${primary}!important`,
	'& > div': pillStyle,
};

const startOnlySx = {
	borderRadius: '50%!important',
	border: `2px solid ${primary}!important`,
	backgroundColor: 'white!important',
	color: `${primary}!important`,
};

const endSx = {
	borderRadius: 0,
	borderWidth: '0!important',
	background: `linear-gradient(to right, ${primary} 50%, white 50%)`,
	color: `${primary}!important`,
	'& > div': pillStyle,
};

interface ICustomDays {
	pickersDayProps: PickersDayProps<Dayjs>;
	isInRange: boolean | null;
	isStart: boolean | null;
	isEnd: boolean | null;
	dateEnd: Dayjs | null;
}

const CustomDays = ({
	pickersDayProps,
	isInRange,
	isStart,
	isEnd,
	dateEnd,
}: ICustomDays) => {
	const sx = {
		...(pickersDayProps.today && todaySx(isInRange)),
		...(isInRange && inRangeSx),
		...(isStart && dateEnd && startWithEndSx),
		...(isStart && !dateEnd && startOnlySx),
		...(isEnd && endSx),
	};

	return (
		<PickersDay {...pickersDayProps} key={pickersDayProps.day.toString()} sx={sx}>
			<Stack>{dayjs(pickersDayProps.day).get('D')}</Stack>
		</PickersDay>
	);
};

export default CustomDays;
